import React from 'react';
import { Layout, Typography, Button } from 'antd';

const { Header, Content } = Layout;
const { Title } = Typography;

const supportLink =
  'https://script.google.com/macros/s/AKfycbzBkSQ3ZAweSTkSIm4NxeFSN9fdfem9dGd6a1tPWnOb8zFhQRoZETXY04CHIGuEK3aM/exec';

const Support = () => {
  return (
    <Layout
      style={{
        backgroundColor: 'transparent',
      }}
    >
      <Header
        style={{
          backgroundColor: 'transparent',
          textAlign: 'center',
          padding: 0,
          height: 'auto',
        }}
      >
        <Title level={2}>Necesitas ayuda?</Title>
      </Header>
      <Content
        style={{
          margin: '24px 16px',
          padding: 24,
          minHeight: 280,
          textAlign: 'center',
        }}
      >
        <Button type="primary">
          <a href={supportLink} target="_blank" rel="noopener noreferrer">
            Contactar a Soporte
          </a>
        </Button>
      </Content>
    </Layout>
  );
};

export default Support;
